module.exports = __webpack_public_path__ + "static/media/lvjian-wuxi.8a7adaf1.jpg";